<template>
  <div class="card-content">
    <div class="columns is-multiline">
      <div class="column is-6">
        <b-field :label="$t('addAgence.informationsAgences.code')" class="obligatoire">
          <b-input v-model="agence.codeAgence"></b-input>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field :label="$t('addAgence.informationsAgences.societeAssocie')"
                 class="obligatoire">
          <b-input v-model="societeLibelle" disabled></b-input>
        </b-field>
      </div>
      <div class="column is-12">
        <b-field :label="$t('addAgence.informationsAgences.libelle')" class="obligatoire">
          <b-input v-model="agence.libelle"></b-input>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field :label="$t('addAgence.informationsAgences.email')">
          <b-input v-model="agence.emailPrincipal"></b-input>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field :label="$t('addAgence.informationsAgences.telephone')">
          <b-input v-model="agence.telephone"></b-input>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field :label="$t('addAgence.informationsAgences.fax')">
          <b-input v-model="agence.fax"></b-input>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    agence: {
      type: Object,
      required: true,
    },
    societeLibelle: {
      type: String,
      required: true,
    },
  },
};

</script>
